import * as React from 'react';
import { Shimmer, ShimmerElementsGroup, ShimmerElementType, IShimmerElement } from '@fluentui/react/lib/Shimmer';
import styles from './ArticleLoader.module.css';

const getLoaderElements = (): JSX.Element => {
    const HEIGHT = 10; // height for all elements on the right side of loader
    const gap: IShimmerElement = {
        type: ShimmerElementType.gap,
        width: '100%',
        height: HEIGHT,
    };

    return (
        <div className={styles.shimmerInnerWrap}>
            <ShimmerElementsGroup
                shimmerElements={[
                    { type: ShimmerElementType.gap, width: 10, height: 100 },
                    { type: ShimmerElementType.line, width: 150, height: 100 },
                    { type: ShimmerElementType.gap, width: 10, height: 100 },
                ]}
            />

            <div className={styles.shimmerRight}>
                <ShimmerElementsGroup
                    flexWrap
                    className={styles.shimmerRight}
                    shimmerElements={[
                        {
                            type: ShimmerElementType.line,
                            width: '95%',
                            height: HEIGHT,
                        },
                        {
                            type: ShimmerElementType.gap,
                            width: '5%',
                            height: HEIGHT,
                        },
                        {
                            type: ShimmerElementType.line,
                            width: '95%',
                            height: HEIGHT,
                        },
                        {
                            type: ShimmerElementType.gap,
                            width: '5%',
                            height: HEIGHT,
                        },
                        gap,
                        {
                            type: ShimmerElementType.line,
                            width: '37%',
                            height: HEIGHT,
                        },
                        {
                            type: ShimmerElementType.gap,
                            width: '3%',
                            height: HEIGHT,
                        },
                        {
                            type: ShimmerElementType.line,
                            width: '50%',
                            height: HEIGHT,
                        },
                        {
                            type: ShimmerElementType.gap,
                            width: '10%',
                            height: HEIGHT,
                        },
                        gap,
                        {
                            type: ShimmerElementType.line,
                            width: '80%',
                            height: HEIGHT,
                        },
                        {
                            type: ShimmerElementType.gap,
                            width: '20%',
                            height: HEIGHT,
                        },
                        gap,
                        {
                            type: ShimmerElementType.line,
                            width: '12%',
                            height: HEIGHT,
                        },
                        {
                            type: ShimmerElementType.gap,
                            width: '3%',
                            height: HEIGHT,
                        },
                        {
                            type: ShimmerElementType.line,
                            width: '32%',
                            height: HEIGHT,
                        },
                        {
                            type: ShimmerElementType.gap,
                            width: '3%',
                            height: HEIGHT,
                        },
                        {
                            type: ShimmerElementType.line,
                            width: '40%',
                            height: HEIGHT,
                        },
                        {
                            type: ShimmerElementType.gap,
                            width: '10%',
                            height: HEIGHT,
                        },
                        gap,
                        {
                            type: ShimmerElementType.line,
                            width: '20%',
                            height: HEIGHT,
                        },
                        {
                            type: ShimmerElementType.gap,
                            width: '80%',
                            height: HEIGHT,
                        },
                    ]}
                />
            </div>
        </div>
    );
};

interface ArticleLoaderProps {
    isDataLoaded: boolean;
    children?: React.ReactChild;
}

const ArticleLoader: React.FC<ArticleLoaderProps> = ({ isDataLoaded, children }) => (
    <Shimmer customElementsGroup={getLoaderElements()} isDataLoaded={isDataLoaded}>
        {children}
    </Shimmer>
);

export default ArticleLoader;
